<template>
    <nav class="lang-switch" :class="{ 'is-open': isOpen }">
        <button class="lang-switch__toggle | lang-switch__btn" role="button" @click="isOpen = !isOpen">
            <abbr v-html="lang.toUpperCase()"></abbr>
        </button>

        <ul class="lang-switch__list">
            <li class="lang-switch__item | lang-switch__btn" :class="{ 'is-current': lang === 'fr' }" @click="onChangeLangClick('fr')">
                <a href="#">FR</a>
            </li>
            <li class="lang-switch__item | lang-switch__btn" :class="{ 'is-current': lang === 'en' }" @click="onChangeLangClick('en')">
                <a href="#">EN</a>
            </li>
        </ul>
    </nav>
</template>

<script>

export default {
    /* Settings
    --------------------------------------------------------- */

    name: 'LangSwitch',

    components: {
    },

    props: {
        lang: { type: String, required: true },
    },

    data() {
        return {
            isOpen: false,
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        //
    },


    watch: {
        //
    },


    /* Methods
    --------------------------------------------------------- */

    methods: {
        onChangeLangClick(lang) {
            this.$emit('change:lang', lang)
            this.isOpen = false
        },
    },


    /* Handlers
    --------------------------------------------------------- */


}

</script>
